import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { Row, Col } from 'antd';

import { RootState } from '../../../../../application/store';
import { Product } from '../../../../../api-client';

import './bv-destinations.scss';

import BVEmpty from '../../../../../common/components/BVEmpty/bv-empty';
import BVDestinationsCard from './components/BVDestinationsCard/bv-destinations-card';

interface IBVDestinations {
    disabled?: boolean;
    product?: Product;
}

const BVDestinations: React.FunctionComponent<IBVDestinations> = ({ disabled, product }) => {
    const bvOrderSummary = useSelector((state: RootState) => state.orderSummary);

    const _handleDestinations = () => {
        if (!bvOrderSummary) {
            return [];
        }

        let currentDestinations = _.filter(bvOrderSummary.products, entry => entry.id === product?.id);
        if (currentDestinations.length === 0) {
            return [];
        }

        return _.sortBy(currentDestinations, entry => entry.deliveryDate);
    }

    return (
        <div className="bv-destinations-container">
            <BVEmpty dataSource={_handleDestinations() || []} disclaimer={'No destinations found for current product.'}>
                <Row gutter={[24, 30]}>
                    {_.map(_handleDestinations(), (dataItem, dataIndex) => (
                        <Col key={dataIndex} span={6}>
                            <BVDestinationsCard
                                disabled={disabled}
                                product={dataItem}
                            />
                        </Col>
                    ))}
                </Row>
            </BVEmpty>
        </div>
    );
}

export default BVDestinations;